<script lang="ts">
  import FullPageShell from "$lib/components/layout/FullPageShell.svelte";
  import Wizard from "$lib/components/onboarding/Wizard.svelte";
  import OrgForm from "$lib/components/identity/OrgForm.svelte";
  import LogoGraphic from "$assets/icons/logo-graphic.svelte";
  import OrgAdminsForm from "$lib/components/identity/OrgAdminsForm.svelte";

  let step = 0;
  $: step;

  const steps = [
    {
      title: "Create your Organisation",
      subtitle: "Set up your organisation by assigning a name and org ID",
      component: OrgForm,
    },
    {
      title: "Add Admins",
      subtitle:
        "Add specific users as org admins, these accounts will have full access to change settings and add members",
      component: OrgAdminsForm,
    },
  ];

  const onFinish = () => {
    window.close();
  };
</script>

<FullPageShell
  mainClass="overflow-auto max-h-[100svh] !pb-0 onboarding"
  class="flex flex-col items-center gap-8 md:gap-12"
  hasBackground={true}
>
  <div class="mt-4 md:mt-12 flex flex-col items-center gap-4 md:gap-6">
    <div class="[&>svg]:h-7 md:[&>svg]:h-12">
      <LogoGraphic />
    </div>
    <div class="flex flex-col items-center gap-1 md:gap-2 text-center">
      <h1>{steps[step].title}</h1>
      <p>{steps[step].subtitle}</p>
    </div>
  </div>

  <div class="flex-1 flex flex-col w-full max-w-2xl">
    <Wizard {steps} {onFinish} bind:wizardStep={step} />
  </div>
</FullPageShell>
